import { Card, Stack, Typography } from "@mui/material";
import { Icon } from "iconsax-react";

interface IBroadcastCardInfo {
  Icon: Icon;
  color: string;
  subTitle?: string;
  title?: string;
}

export default function BroadcastCardInfo({
  Icon,
  color,
  subTitle,
  title,
}: Readonly<IBroadcastCardInfo>) {
  return (
    <Card
      sx={{
        boxShadow: "none",
        display: "flex",
        flexDirection: "row",
        borderRadius: "4px",
        width: "100%",
        borderColor: (theme) => theme.palette.others.borderColor,
        borderWidth: "1px",
        borderStyle: "solid",
      }}
    >
      <Stack
        bgcolor={color}
        direction="row"
        alignItems="center"
        justifyContent="center"
        p="20px"
      >
        <Icon color={"white"} size={35} />
      </Stack>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="start"
        mx="6px"
        sx={{
          py: "12px",
          px: "20px",
        }}
      >
        <Typography
          variant="captionDemiBold"
          color={(thm) => thm.palette.dark[10]}
        >
          {subTitle}
        </Typography>
        <Typography
          variant="footerMediumBold"
          color={(thm) => thm.palette.dark[40]}
        >
          {title}
        </Typography>
      </Stack>
    </Card>
  );
}
